const waterTankStatusMap: Record<string, string> = {
  "0": "未装着",
  "1": "装着済み",
} as const;

/**
 * Dreameロボットの waterTankStatus から表示用のラベルを取得する
 */
export const getDreameRobotWaterTankStatusLabel = (status: string) => {
  return waterTankStatusMap[status] ?? "不明なステータス";
};
